itsoftApp.createModule("dropdown", function() {
    var dropdownBtnClass = "js-dropdown-btn";
    var dropdownBtn = $("." + dropdownBtnClass);

    if (!dropdownBtn.length) {
        return false;
    }

    var dropdownClass = "js-dropdown";
    var dropdown = $("." + dropdownClass);
    var activeClass = "is-active";

    dropdownBtn.on("click", function(){
        if (dropdown.hasClass(activeClass)){
            dropdown.removeClass(activeClass);
        }
        else{
            dropdown.addClass(activeClass);
        }
    })


});